"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceOwnerRequestSchema = exports.MarketplaceOwnerRequestStatusSchema = exports.MarketplaceRequestDocumentSchema = void 0;
const zod_1 = require("zod");
exports.MarketplaceRequestDocumentSchema = zod_1.z.object({
    documentId: zod_1.z.string(),
    name: zod_1.z.string(),
    status: zod_1.z.enum(['requested', 'uploaded', 'verified', 'rejected']),
    comment: zod_1.z.string().optional(),
    fileKey: zod_1.z.string().optional(),
    fileName: zod_1.z.string().optional(),
    contentType: zod_1.z.string().optional(),
    uploadedAt: zod_1.z.string().optional(),
    required: zod_1.z.boolean().optional(),
    isDefault: zod_1.z.boolean().optional(),
});
exports.MarketplaceOwnerRequestStatusSchema = zod_1.z.enum([
    'pending',
    'info_requested',
    'payment_pending',
    'active',
    'grace',
    'inactive',
    'rejected',
]);
exports.MarketplaceOwnerRequestSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    requestId: zod_1.z.string(),
    // The location the tenant proposes to run the marketplace from; becomes
    // ownerLocationId on approval.
    requestedLocationId: zod_1.z.string(),
    ownerLocationId: zod_1.z.string().optional(),
    businessName: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    regulatedGoods: zod_1.z.array(zod_1.z.string()).optional(),
    documents: zod_1.z.array(exports.MarketplaceRequestDocumentSchema),
    status: exports.MarketplaceOwnerRequestStatusSchema,
    paymentStatus: zod_1.z.enum(['none', 'pending', 'active', 'past_due', 'cancelled']).default('none'),
    statusRequestedAt: zod_1.z.string(), // `${status}#${ISO}` — GSI sort key
    rejectedReason: zod_1.z.string().optional(),
    infoRequestMessage: zod_1.z.string().optional(),
    tenantResponse: zod_1.z.string().optional(),
    priceId: zod_1.z.string().optional(),
    priceAmount: zod_1.z.number().optional(),
    stripeCheckoutSessionId: zod_1.z.string().optional(),
    stripeSubscriptionId: zod_1.z.string().optional(),
    stripeEventId: zod_1.z.string().optional(),
    gracePeriodEnds: zod_1.z.string().optional(),
    approvedBy: zod_1.z.string().optional(),
    approvedAt: zod_1.z.string().optional(),
    rejectedAt: zod_1.z.string().optional(),
    requestedAt: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
//# sourceMappingURL=marketplace-owner-request.schema.js.map